import { formatter, request } from '@/utils/request';

export namespace OA {
  export const Path = {
    QueryProgram: '/thirdpartyapi/oa/queryProgram',
    queryContract: '/thirdpartyapi/oa/queryContract',
    SearchContract: '/thirdpartyapi/oa/searchContract',
  };

  export async function queryProgram(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.QueryResult<API.OaProgramVo>>(Path.QueryProgram, formatter(options));
  }

  export async function queryContract(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.QueryResult<API.OaContractVo>>(Path.queryContract, formatter(options));
  }
}
